import { useLocalStorageState } from 'app/shared/hooks/useLocalStorage';
import { LocalStorageKeys } from 'app/shared/constants/localStorage';
import { DEFAULT_REPORT_CHARTS } from 'app/modules/reportDashboards/constants';
import {
  ReportSection,
  SavedReportSection,
} from 'app/modules/reportDashboards/models';
import {
  getSavableReportDashboardConfig,
  mergeReportDashboardConfig,
} from 'app/modules/reportDashboards/utils';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { selectSessionAgentPermissions } from 'app/modules/session/selectors';

export const useReportDashboardsStorage = () => {
  const userPermissions = useSelector(selectSessionAgentPermissions);

  const [config, setConfig] = useLocalStorageState<SavedReportSection[]>(
    LocalStorageKeys.REPORT_DASHBOARDS_CONFIG,
    getSavableReportDashboardConfig(DEFAULT_REPORT_CHARTS),
  );

  const mergedConfig = useMemo(
    () =>
      mergeReportDashboardConfig(
        config,
        DEFAULT_REPORT_CHARTS,
        userPermissions,
      ),
    [config, userPermissions],
  );

  const saveConfig = (newConfig: ReportSection[]) => {
    setConfig(getSavableReportDashboardConfig(newConfig));
  };

  const resetConfig = () => {
    setConfig(getSavableReportDashboardConfig(DEFAULT_REPORT_CHARTS));
  };

  return {
    config: mergedConfig,
    saveConfig,
    resetConfig,
  };
};
